import * as React from "react";
import {Card, Button} from "web-com";
import "../style.scss";
import {COLOR} from "utils/variables";

interface IStatus {
    heading: string;
    desc: string;
    iconUrl: string;
    buttonText: string;
}

interface IProps {
    status: IStatus;
    onClick: () => void;
}

const StatusCard = (props: IProps) => {
    return (
        <Card>
            <div className="dashboard-status-container">
                <div className="left-container">
                    <h5 className="heading">{props.status.heading}</h5>
                    <p className="desc">{props.status.desc}</p>
                </div>
                <div className="right-container">
                    <img src={props.status.iconUrl}/>
                    <Button
                        buttonText={props.status.buttonText}
                        onClick={() => props.onClick()}
                        bgColor={COLOR.PRIMARY}
                        width={"90%"}
                        height={40}
                    />
                </div>
            </div>
        </Card>
    );
};

export default StatusCard;
